export const applyTheme = (theme, options) => {
    const selected = options.find((opt) => opt.name === theme);
    if (selected) {
        selected.options.forEach(([cssVariable, cssValue]) => {
            document.documentElement.style.setProperty(cssVariable, cssValue);
        });
    }
};
//# sourceMappingURL=applyTheme.js.map